import React, {VoidFunctionComponent} from 'react';
import {useHistory, useRouteMatch} from 'react-router-dom';
import {useIntl} from 'react-intl';
import cx from 'classnames';

import StaticTextScreen from '../static-text-screen/static-text-screen';
import IconButton from '../icon-button/icon-button';
import CloseIcon from '../icons/close/close';

import styles from './info-screen.module.css';
import ReactMarkdown from 'react-markdown';

const InfoScreen: VoidFunctionComponent<Record<string, unknown>> = () => {
  const intl = useIntl();
  const history = useHistory();
  const matchInfo = useRouteMatch('/info');

  const closeInfo = () => {
    history.push('/');
  };

  return (
    <div className={cx(styles.container, matchInfo && styles.showOnMobile)}>
      <IconButton
        className={styles.closeButton}
        variant="secondary"
        onClick={closeInfo}>
        <CloseIcon />
      </IconButton>

      <StaticTextScreen headlineId="info.headline">
        <div className={styles.text}>
          <ReactMarkdown children={intl.formatMessage({id: 'info.text'})} />
        </div>
      </StaticTextScreen>
    </div>
  );
};

export default InfoScreen;
